export default "__VITE_ASSET__C6ruW_Gz__"